export { default as EducationFocusComponent } from './EducationFocusComponent';
